
// 精选图书引入图片
import moduleTitle from '../assets/img/home/select_book_title.png'
import L0 from '../assets/img/home/L0.png'
import L1 from '../assets/img/home/L1.png'
import L2 from '../assets/img/home/L2.png'
import L3 from '../assets/img/home/L3.png'
import L4 from '../assets/img/home/L4.png'
import L5 from '../assets/img/home/L5.png'
import L6 from '../assets/img/home/L6.png'

export default {
    namespaced:true,
    state:{
        // moduleTitle:moduleTitle,
        Imglist:{
            moduleTitle:moduleTitle,
            list:[
                {id:'L0',level:L0,title:'L0'},
                {id:'L1',level:L1,title:'L1'},
                {id:'L2',level:L2,title:'L2'},
                {id:'L3',level:L3,title:'L3'},
                {id:'L4',level:L4,title:'L4'},
                {id:'L5',level:L5,title:'L5'},
                {id:'L6',level:L6,title:'L6'},
        ]
    }
}
    
}